import React from "react";

import { ProfileManagement } from "@components/Profile";

export default function ProfileIndex() {
  return <ProfileManagement />;
}
